__turbopack_context__.v({
  "active": "P3k4OW_active",
  "activeSubcategory": "P3k4OW_activeSubcategory",
  "categoriesContainer": "P3k4OW_categoriesContainer",
  "categoriesGrid": "P3k4OW_categoriesGrid",
  "categoryContent": "P3k4OW_categoryContent",
  "categoryHeader": "P3k4OW_categoryHeader",
  "categoryList": "P3k4OW_categoryList",
  "categorySection": "P3k4OW_categorySection",
  "categoryTitle": "P3k4OW_categoryTitle",
  "chevronIcon": "P3k4OW_chevronIcon",
  "emptyColumn": "P3k4OW_emptyColumn",
  "loadingMessage": "P3k4OW_loadingMessage",
  "menuContainer": "P3k4OW_menuContainer",
  "nestedSubcategories": "P3k4OW_nestedSubcategories",
  "nestedSubcategoryLink": "P3k4OW_nestedSubcategoryLink",
  "noCategoriesMessage": "P3k4OW_noCategoriesMessage",
  "rotated": "P3k4OW_rotated",
  "row": "P3k4OW_row",
  "sectionTitle": "P3k4OW_sectionTitle",
  "selectedCategoryHeader": "P3k4OW_selectedCategoryHeader",
  "selectedTab": "P3k4OW_selectedTab",
  "subcategoryItem": "P3k4OW_subcategoryItem",
  "subcategoryLink": "P3k4OW_subcategoryLink",
  "subcategoryList": "P3k4OW_subcategoryList",
  "tabButton": "P3k4OW_tabButton",
  "tabButtons": "P3k4OW_tabButtons",
  "tabContent": "P3k4OW_tabContent",
  "tabHeader": "P3k4OW_tabHeader",
  "tabLayout": "P3k4OW_tabLayout",
  "tabTitle": "P3k4OW_tabTitle",
});
